webpackJsonp([1],{

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(90)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(91),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);






var handleSuccess = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(response) {
    var contentType;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(response.status === 204)) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt('return', response);

          case 2:
            contentType = response.headers.get('Content-Type');

            if (!(!contentType || !contentType.includes('application/json'))) {
              _context5.next = 5;
              break;
            }

            return _context5.abrupt('return', response);

          case 5:
            _context5.next = 7;
            return response.json();

          case 7:
            return _context5.abrupt('return', _context5.sent);

          case 8:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function handleSuccess(_x11) {
    return _ref5.apply(this, arguments);
  };
}();

var FetchService = function () {
  function FetchService() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, FetchService);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(FetchService, [{
    key: 'get',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(url, options) {
        var requestConfig, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                requestConfig = getBasicRequestConfig(options);

                requestConfig.method = 'get';
                _context.next = 4;
                return fetch('/api/notifications/' + url);

              case 4:
                response = _context.sent;

                if (!didRequestFail(response)) {
                  _context.next = 7;
                  break;
                }

                throw createRequestFailedError(response);

              case 7:
                _context.next = 9;
                return handleSuccess(response);

              case 9:
                return _context.abrupt('return', _context.sent);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: 'post',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(url, data, options) {
        var requestConfig, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                requestConfig = getBasicRequestConfig(options);


                requestConfig.headers['Accept'] = 'application/json; charset=utf-8';
                requestConfig.headers['Content-Type'] = 'application/json; charset=utf-8';
                requestConfig.method = 'post';
                requestConfig.body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);

                _context2.next = 7;
                return fetch('/api/notifications/' + url, requestConfig);

              case 7:
                response = _context2.sent;

                if (!didRequestFail(response)) {
                  _context2.next = 10;
                  break;
                }

                throw createRequestFailedError(response);

              case 10:
                _context2.next = 12;
                return handleSuccess(response);

              case 12:
                return _context2.abrupt('return', _context2.sent);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function post(_x3, _x4, _x5) {
        return _ref2.apply(this, arguments);
      }

      return post;
    }()
  }, {
    key: 'put',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(url, data, options) {
        var requestConfig, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                requestConfig = getBasicRequestConfig(options);

                requestConfig.headers['Accept'] = 'application/json';
                requestConfig.headers['Content-Type'] = 'application/json';
                requestConfig.method = 'put';
                requestConfig.body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
                _context3.next = 7;
                return fetch('/api/notifications/' + url, requestConfig);

              case 7:
                response = _context3.sent;

                if (!didRequestFail(response)) {
                  _context3.next = 10;
                  break;
                }

                throw createRequestFailedError(response);

              case 10:
                _context3.next = 12;
                return handleSuccess(response);

              case 12:
                return _context3.abrupt('return', _context3.sent);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function put(_x6, _x7, _x8) {
        return _ref3.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: 'delete',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(url, options) {
        var requestConfig, response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                requestConfig = getBasicRequestConfig(options);

                requestConfig.headers['Accept'] = 'application/json; charset=utf-8';
                requestConfig.headers['Content-Type'] = 'application/json; charset=utf-8';
                requestConfig.method = 'delete';
                _context4.next = 6;
                return fetch('/api/notifications/' + url, requestConfig);

              case 6:
                response = _context4.sent;

                if (!didRequestFail(response)) {
                  _context4.next = 9;
                  break;
                }

                throw createRequestFailedError(response);

              case 9:
                _context4.next = 11;
                return handleSuccess(response);

              case 11:
                return _context4.abrupt('return', _context4.sent);

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _delete(_x9, _x10) {
        return _ref4.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return FetchService;
}();

function getBasicRequestConfig(options) {
  var includeCredentials = options && options.includeCredentials || false;
  var requestConfig = {
    credentials: includeCredentials ? 'same-origin' : 'omit',
    headers: {
      'no-gui-request': 'no-gui',
      'AntiForgeryToken': document.getElementsByName('__RequestVerificationToken')[0].value
    }
  };
  if (options && options.signal) requestConfig.signal = options.signal;
  return requestConfig;
}

function didRequestFail(response) {
  return response.status >= 400 && response.status < 600;
}

function createRequestFailedError(response) {
  var error = new Error(response.status + ' ' + response.statusText);
  error.status = response.status;
  return error;
}

/* harmony default export */ __webpack_exports__["a"] = (new FetchService());

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IssueNotificationsRegistration__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IssueNotificationsRegistration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__IssueNotificationsRegistration__);





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

var NotificationVue = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].extend({
  data: function data() {
    return {
      data: JSON.parse(document.getElementById('issue-notifications-registration').getAttribute('data-issue-notifications-registration')),
      dataRecaptchaInformationText: document.getElementById('issue-notifications-registration').getAttribute('data-issue-notifications-registration-RecaptchaInformationText'),
      cmsDataMainBody: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(document.getElementById('issue-notifications-registration').getAttribute('data-issue-notifications-registration-mainBody'))),
      cmsDataCreateSubscriptionConfirmationPopupText: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(document.getElementById('issue-notifications-registration').getAttribute('data-issue-notifications-registration-CreateSubscriptionConfirmationPopupText')))
    };
  }
});

if (document.getElementById('issue-notifications-registration')) {
  new NotificationVue({
    el: '#issue-notifications-registration',
    template: '<issue-notifications-registration />',
    components: { IssueNotificationsRegistration: __WEBPACK_IMPORTED_MODULE_2__IssueNotificationsRegistration___default.a }
  });
}

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fetchService__ = __webpack_require__(39);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'issue-notifications-registration',
  data: function data() {
    return {
      SubscriptionType: this.getQueryStringParameter('vt'),
      ProceedingTitle: this.$root.data.ProceedingTitle,
      ProceedingIdString: this.$root.data.ProceedingIdString,
      CommitteeTitle: this.$root.data.CommitteeTitle,
      CommitteeIdString: this.$root.data.CommitteeIdString,
      NotificationPopupHeading: this.$root.data.NotificationPopupHeading,
      Ingress: this.$root.data.Ingress,
      MainBody: this.$root.cmsDataMainBody,
      SubscriptionConfirmationPopupText: this.$root.cmsDataCreateSubscriptionConfirmationPopupText,
      EmailHeading: this.$root.data.EmailHeading,
      EmailPlaceholder: this.$root.data.EmailPlaceholder,
      CreateSubscriptionButtonText: this.$root.data.CreateSubscriptionButtonText,
      newEmail: '',
      showNewContactEmailSentConfirmation: false,
      registrationTriggered: false,
      showNewContactError: false,
      newContactErrorMessage: this.$root.data.createNewContactErrorMessage,
      issueNotificationsLoginPageLinkText: this.$root.data.issueNotificationsLoginPageLinkText,
      issueNotificationsLoginPageUrl: this.$root.data.issueNotificationsLoginPageUrl,
      gdpr: {
        consentText: this.$root.data.GdprConsent.Text,
        privacyPolicyUrl: this.$root.data.GdprConsent.PrivacyPolicyUrl,
        privacyPolicyLinkText: this.$root.data.GdprConsent.PrivacyPolicyLinkText,
        consentGiven: {
          registerNewUser: false
        }
      },
      working: false
    };
  },

  methods: {
    registerUser: function registerUser(recaptchaToken) {
      var _this = this;

      this.working = true;
      this.showNewContactError = false;
      this.registrationTriggered = true;

      if (!recaptchaToken) {
        this.showNewContactError = true;
        return;
      }

      var data = this.createRequestData(this.newEmail, recaptchaToken);

      __WEBPACK_IMPORTED_MODULE_0__fetchService__["a" /* default */].post('contact/CreateNewContact/', data, { includeCredentials: true }).then(function () {
        _this.showNewContactEmailSentConfirmation = true;
      }).catch(function () {
        _this.registrationTriggered = false;
        _this.showNewContactError = true;
      }).finally(function () {
        _this.working = false;
      });
    },
    getCurrentLanguage: function getCurrentLanguage() {
      return document.querySelector('html').getAttribute('lang');
    },
    getQueryStringParameter: function getQueryStringParameter(parameterName) {
      var result = null;
      var temp = [];

      location.search.substr(1).split('&').forEach(function (item) {
        temp = item.split('=');
        if (temp[0] === parameterName) result = decodeURIComponent(temp[1]);
      });

      return result;
    },
    createRequestData: function createRequestData(email, recaptchaToken) {
      var lang = this.getCurrentLanguage();
      var data = {
        email: email,
        lang: lang,
        recaptchaToken: recaptchaToken
      };

      if (this.hasSelectedIssueInformation()) {
        data.subscriptionId = this.ProceedingIdString;
        data.subscriptionType = this.SubscriptionType;
      }

      if (this.hasSelectedCommitteeInformation()) {
        data.subscriptionId = this.CommitteeIdString;
        data.subscriptionType = this.SubscriptionType;
      }

      return data;
    },
    hasSelectedIssueInformation: function hasSelectedIssueInformation() {
      console.log('hasSelectedIssueInformation', this.ProceedingIdString, this.ProceedingTitle);
      return this.ProceedingIdString && this.ProceedingTitle && this.SubscriptionType;
    },
    hasSelectedCommitteeInformation: function hasSelectedCommitteeInformation() {
      console.log('hasSelectedCommitteeInformation', this.CommitteeIdString, this.CommitteeTitle);
      return this.CommitteeIdString && this.CommitteeTitle && this.SubscriptionType;
    },
    submitWithRecaptcha: function submitWithRecaptcha(callback) {
      if (!this.$root.data.recaptchaSiteKey) {
        throw 'Missing recaptcha site key.';
      }

      if (!this.$root.data.recaptchaAction) {
        throw 'Missing recaptcha action.';
      }

      if (!window.grecaptcha) {
        throw 'Grecaptcha is undefined.';
      }

      window.grecaptcha.execute(this.$root.data.recaptchaSiteKey, { action: this.$root.data.recaptchaAction }).then(callback);
    }
  }
});

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "issue-notifications-registration-page-url",
    attrs: {
      "href": _vm.issueNotificationsLoginPageUrl
    }
  }, [_vm._v(_vm._s(_vm.issueNotificationsLoginPageLinkText))]), _vm._v(" "), (_vm.hasSelectedIssueInformation()) ? _c('div', {
    staticClass: "panel notice"
  }, [(_vm.hasSelectedIssueInformation()) ? _c('div', [_c('h2', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.NotificationPopupHeading))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.ProceedingTitle))])]) : _vm._e(), _vm._v(" "), (_vm.hasSelectedCommitteeInformation()) ? _c('div', [_c('h2', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.NotificationPopupHeading))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.CommitteeTitle))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "article-excerpt",
    domProps: {
      "innerHTML": _vm._s(_vm.Ingress)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block-article block-article-mobile",
    domProps: {
      "innerHTML": _vm._s(_vm.MainBody)
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "aria-live": "polite"
    }
  }, [(!_vm.showNewContactEmailSentConfirmation) ? _c('div', [_c('h2', {
    attrs: {
      "id": "registration-form-heading"
    }
  }, [_vm._v(_vm._s(_vm.EmailHeading))]), _vm._v(" "), (_vm.showNewContactError) ? _c('div', [_c('div', {
    staticClass: "panel alarmbanner"
  }, [_c('p', [_vm._v("\n            " + _vm._s(_vm.newContactErrorMessage) + "\n          ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "medium-6 columns form-area"
  }, [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    attrs: {
      "type": "email",
      "placeholder": _vm.EmailPlaceholder,
      "aria-labelledby": "registration-form-heading"
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "checkbox-fullwidth"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gdpr.consentGiven.registerNewUser),
      expression: "gdpr.consentGiven.registerNewUser"
    }],
    attrs: {
      "type": "checkbox",
      "name": "gdpr-consent-checkbox-register-new-user",
      "id": "gdpr-consent-checkbox-register-new-user"
    },
    domProps: {
      "checked": Array.isArray(_vm.gdpr.consentGiven.registerNewUser) ? _vm._i(_vm.gdpr.consentGiven.registerNewUser, null) > -1 : (_vm.gdpr.consentGiven.registerNewUser)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.gdpr.consentGiven.registerNewUser,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.gdpr.consentGiven.registerNewUser = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.gdpr.consentGiven.registerNewUser = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.gdpr.consentGiven, "registerNewUser", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "gdpr-consent-checkbox-register-new-user"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.gdpr.consentText) + " "), _c('a', {
    attrs: {
      "href": _vm.gdpr.privacyPolicyUrl
    }
  }, [_vm._v(_vm._s(_vm.gdpr.privacyPolicyLinkText))])])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(this.$root.dataRecaptchaInformationText)
    }
  })])]), _vm._v(" "), _c('p'), _c('div', {
    staticClass: "issue-notification-cta-container"
  }, [(_vm.working) ? _c('img', {
    staticClass: "loader-gif",
    attrs: {
      "src": "/Web/FrontEndR/assets/gfx/loader-transparent.gif"
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button submit",
    attrs: {
      "type": "button",
      "disabled": this.registrationTriggered === true || this.newEmail === '' || !_vm.gdpr.consentGiven.registerNewUser
    },
    on: {
      "click": function($event) {
        _vm.submitWithRecaptcha(_vm.registerUser)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.CreateSubscriptionButtonText))])])]), _vm._v(" "), _c('p')]) : _c('div', [_c('div', {
    staticClass: "panel notice"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.SubscriptionConfirmationPopupText)
    }
  })])])])])
},staticRenderFns: []}

/***/ })

},[40]);


// WEBPACK FOOTER //
// static/js/app.js